import { Trip, Content } from './../classes.js';

export function youtube__element(data, edit = false){
	let $content = '';
	let $as_label = '';
	let $as_input = '';
	
	let doc = {
		'documentElement': {
			'textContent' : ''
		}
	};
	let url = '';
	let vid = '';
	let youtube_id = '';
	
	if(data.c.youtube != '' && typeof(data.c.youtube) != 'undefined'){
		doc = new DOMParser().parseFromString(data.c.youtube, "text/html");
		url = new URL(data.c.youtube);
	}else{
		doc = new DOMParser().parseFromString("https://www.youtube.com/watch?v=dQw4w9WgXcQ&list=RDdQw4w9WgXcQ", "text/html");
		url = new URL("https://www.youtube.com/watch?v=dQw4w9WgXcQ&list=RDdQw4w9WgXcQ");
	}
	
	vid = new URLSearchParams(url.search);
	youtube_id = vid.get('v');
	
	//create the trip title element // edit or read
	if(edit){
		$content = $('<div/>', {
			'class': 'e editable form__row',
			'data-el_id': data.id,
			'data-block_id': data.block_id
		});
		
		$as_label = $('<label/>', {
			'class': 'fake_label',
			'text': 'youtube URL',
			'for': `youtube__${data.id}`
		});
		
		$as_input = $('<input/>', {
			'name': `b[${data.block_id}][e][${data.id}][c][youtube]`,
			'value': typeof(doc.documentElement.textContent) != '' ? doc.documentElement.textContent : '',
			'id': `youtube__${data.id}`,
			'type': 'text',
			'placeholder': 'Youtube URL',
		});
		
		$content.append($as_label, $as_input);
		$content.append(`
			<p class="small margin_top--small">
				<strong>Instructions:</strong>
				Copy and Paste the YouTube link of the youtube you would like to embed in your trip. It should look similar to https://www.youtube.com/watch?v=dQw4w9WgXcQ&list=RDdQw4w9WgXcQ&start_radio=1.
			</p>
		`);
	}else{
	
		$content = $('<div/>', {
			'class': 'e editor',
			'data-el_id': data.id,
			'data-block_id': data.block_id
		});
		
		$content.append(`
			<iframe width="100%" height="420" src="https://www.youtube.com/embed/${youtube_id}?rel=0&modestbranding=1" title="YouTube youtube player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
		`);
		
		
		if(Trip.has_permission || Content.edit){
			$as_input = $('<input/>', {
				'type': 'hidden',
				'name': `b[${data.block_id}][e][${data.id}][c][youtube]`,
				'value': data.c.youtube
			});
			$content.append($as_input);
		}
	}
	if(Trip.has_permission || Content.edit){
		
		$content.append(`<input class="element_order" type="hidden" name="b[${data.block_id}][e][${data.id}][order]" value="${data.order}" />`);
		$content.append(`<input class="element_priority" type="hidden" name="b[${data.block_id}][e][${data.id}][priority]" value="${data.priority}" />`);
		$content.append(`<input type="hidden" name="b[${data.block_id}][e][${data.id}][type]" value="youtube" />`);
	}
		
	return $content;
}